<template>
  <div id="feature-block">
    <div class="feature-nav">
      <div class="feature-nav-content">
        <a-breadcrumb>
          <a-breadcrumb-item><router-link to="/search">项目</router-link></a-breadcrumb-item>
          <a-breadcrumb-item>需求列表</a-breadcrumb-item>
        </a-breadcrumb>
      </div>
    </div>
    <hm-main-card></hm-main-card>
    <div class="feature-content">
      <div class="feature-content-top" @click="goFeatureDetail">
        <span class="feature-content-tip">需求</span>
        <span class="feature-content-tip-value">24</span>
        <a-radio-group class="feature-content-radio" default-value="1" @change="onChange" v-model="radiovalue" size="large">
          <a-radio-button value="1">智能</a-radio-button>
          <a-radio-button value="2">热度</a-radio-button>
          <a-radio-button value="3">最新</a-radio-button>
        </a-radio-group>
        <a-input-search placeholder="请输入需要查询的内容" class="feature-input" @search="onSearch" />
        <a-button  class="add-feature" type="primary" @click="showModal">新建需求</a-button>
        <a-popover placement="bottomRight">
          <template slot="content">
            <p @click="importfeature"><a-icon type="import" style="font-size: 16px" />&nbsp;&nbsp;导入需求</p>
            <p @click="exportfeature"><a-icon type="export" style="font-size: 16px" />&nbsp;&nbsp;导出需求</p>
          </template>
          <a-icon type="plus-circle" class="import-feature" />
          <a-icon type="down" class="import-feature-down" />
        </a-popover>
      </div>
      <div class="feature-content-collapse">
        <a-collapse accordion >
          <a-collapse-panel v-for="(item,index) in featureList" :key="index" :showArrow="false" :bordered="true">
            <div class="custom-collapse-header" slot="header">
              <div class="custom-header-item">
                <img alt="" class="custom-header-img" :src="item.logo">
                <p class="custom-header-title">{{item.title}}&nbsp;&nbsp;<a-icon type="down" class="custom-header-down" /></p>
              </div>
              <div class="custom-header-item custom-header-item-center">
                <div class="header-center-item">
                  <p class="center-item-tip">发布者</p>
                  <p class="center-item-tip-value">{{item.author}}</p>
                </div>
                <div class="header-center-item">
                  <p class="center-item-tip">发布时间</p>
                  <p class="center-item-tip-value">{{item.create_date}}</p>
                </div>
              </div>
              <div class="custom-header-item custom-header-item-right">
                <a-icon class="custom-header-icon" type="like" />
                <span class="custom-header-num">{{item.zan}}</span>
                <a-divider type="vertical" />
                <a-icon class="custom-header-icon" type="message" />
                <span class="custom-header-num">{{item.comment}}</span>
              </div>
            </div>
            <div class="custom-collapse-header custom-collapse-sub" v-for="(subItem,sub_index) in item.subList" :key="sub_index">
              <div class="custom-header-item">
                <p class="custom-header-title">{{subItem.title}}</p>
              </div>
              <div class="custom-header-item custom-header-item-center">
                <img alt="" class="custom-subheader-img" :src="subItem.user_icon">
                <span class="center-item-author">{{subItem.author}}/{{subItem.company_name}}</span>
                <span class="center-item-date">{{subItem.create_date}}</span>
              </div>
              <div class="custom-header-item custom-header-item-right">
                <a-icon class="custom-header-icon" type="like" />
                <span class="custom-header-num">{{subItem.zan}}</span>
                <a-divider type="vertical" />
                <a-icon class="custom-header-icon" type="message" />
                <span class="custom-header-num">{{subItem.comment}}</span>
              </div>
            </div>
          </a-collapse-panel>
        </a-collapse>
      </div>
    </div>
    <a-modal
        :visible="visible"
        @ok="handleOk"
        :confirmLoading="confirmLoading"
        @cancel="handleCancel"
        class="feature-modal-body"
        :footer="null"
        :centered="true"
    >
      <div class="feature-modal">
        <a-input v-model="featureTitle" placeholder="请简要描述一下您的需求" class="feature-modal-title"></a-input>
        <a-input v-model="featureDesc" placeholder="请用一段文件介绍一下该需求" class="feature-modal-desc" type="textarea"/>
        <div class="feature-modal-btn">
          <a-button type="danger">发表</a-button>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
  import HmMainCard from '@/components/HmMainCard/index'
  export default {
    name: "project-feature",
    data() {
      return{
        ModalText: 'Content of the modal',
        visible: false,
        confirmLoading: false,
        featureTitle:'',
        featureDesc:'',
        radiovalue:1,
        featureList:[
          {
            logo:require('@/assets/hm-logo.png'),
            title:'设计一个社区需求',
            author:'James',
            create_date:'2020-04-23 12:00',
            comment:20,
            zan:98,
            subList:[
              {
                title:'这是一个子需求',
                user_icon:require('@/assets/hm-logo.png'),
                author:'郑总',
                company_name:'北京***公司',
                create_date: '2020-04-09 18:00',
                comment:10,
                zan:32,
              },
              {
                title:'这是一个子需求',
                user_icon:require('@/assets/hm-logo.png'),
                author:'郑总',
                company_name:'北京***公司',
                create_date: '2020-04-09 18:00',
                comment:10,
                zan:32,
              },
              {
                title:'这是一个子需求',
                user_icon:require('@/assets/hm-logo.png'),
                author:'郑总',
                company_name:'北京***公司',
                create_date: '2020-04-09 18:00',
                comment:10,
                zan:32,
              },
              {
                title:'这是一个子需求',
                user_icon:require('@/assets/hm-logo.png'),
                author:'郑总',
                company_name:'北京***公司',
                create_date: '2020-04-09 18:00',
                comment:10,
                zan:32,
              }
            ]
          },
          {
            logo:require('@/assets/hm-logo.png'),
            title:'设计一个社区需求',
            author:'James',
            create_date:'2020-04-23 12:00',
            comment:20,
            zan:98,
            subList:[
              {
                title:'这是一个子需求',
                user_icon:require('@/assets/hm-logo.png'),
                author:'郑总',
                company_name:'北京***公司',
                create_date: '2020-04-09 18:00',
                comment:10,
                zan:32,
              },
              {
                title:'这是一个子需求',
                user_icon:require('@/assets/hm-logo.png'),
                author:'郑总',
                company_name:'北京***公司',
                create_date: '2020-04-09 18:00',
                comment:10,
                zan:32,
              }
            ]
          },
          {
            logo:require('@/assets/hm-logo.png'),
            title:'设计一个社区需求',
            author:'James',
            create_date:'2020-04-23 12:00',
            comment:20,
            zan:98,
            subList:[
              {
                title:'这是一个子需求',
                user_icon:require('@/assets/hm-logo.png'),
                author:'郑总',
                company_name:'北京***公司',
                create_date: '2020-04-09 18:00',
                comment:10,
                zan:32,
              },
              {
                title:'这是一个子需求',
                user_icon:require('@/assets/hm-logo.png'),
                author:'郑总',
                company_name:'北京***公司',
                create_date: '2020-04-09 18:00',
                comment:10,
                zan:32,
              }
            ]
          },
          {
            logo:require('@/assets/hm-logo.png'),
            title:'设计一个社区需求',
            author:'James',
            create_date:'2020-04-23 12:00',
            comment:20,
            zan:98,
            subList:[
              {
                title:'这是一个子需求',
                user_icon:require('@/assets/hm-logo.png'),
                author:'郑总',
                company_name:'北京***公司',
                create_date: '2020-04-09 18:00',
                comment:10,
                zan:32,
              }
            ]
          },
          {
            logo:require('@/assets/hm-logo.png'),
            title:'设计一个社区需求',
            author:'James',
            create_date:'2020-04-23 12:00',
            comment:20,
            zan:98,
            subList:[
              {
                title:'这是一个子需求',
                user_icon:require('@/assets/hm-logo.png'),
                author:'郑总',
                company_name:'北京***公司',
                create_date: '2020-04-09 18:00',
                comment:10,
                zan:32,
              },
              {
                title:'这是一个子需求',
                user_icon:require('@/assets/hm-logo.png'),
                author:'郑总',
                company_name:'北京***公司',
                create_date: '2020-04-09 18:00',
                comment:10,
                zan:32,
              },
              {
                title:'这是一个子需求',
                user_icon:require('@/assets/hm-logo.png'),
                author:'郑总',
                company_name:'北京***公司',
                create_date: '2020-04-09 18:00',
                comment:10,
                zan:32,
              }
            ]
          },
          {
            logo:require('@/assets/hm-logo.png'),
            title:'设计一个社区需求',
            author:'James',
            create_date:'2020-04-23 12:00',
            comment:20,
            zan:98,
            subList:[
              {
                title:'这是一个子需求',
                user_icon:require('@/assets/hm-logo.png'),
                author:'郑总',
                company_name:'北京***公司',
                create_date: '2020-04-09 18:00',
                comment:10,
                zan:32,
              }
            ]
          }
        ]
    }
    },
    components: {
      HmMainCard
    },
    methods:{
      showModal() {
        this.visible = true;
      },
      handleOk() {
        this.ModalText = 'The modal will be closed after two seconds';
        this.confirmLoading = true;
        setTimeout(() => {
          this.visible = false;
          this.confirmLoading = false;
        }, 1000);
      },
      handleCancel() {
        this.visible = false;
      },
      goFeatureDetail() {
        this.$router.push({path:'/feature-detail'});
      },
      onChange() {

      },
      onSearch() {

      },
      importfeature() {

      },
      exportfeature() {

      }
    }
  }
</script>

<style lang="less" scoped>
  #feature-block {
    background-color: #F5F5F5;
    .feature-nav {
      width: 100%;
      background-color: #fff;
      height: 60px;
      line-height: 60px;
      margin-bottom: 15px;
      text-align: left;
      .feature-nav-content {
        width: 1400px;
        margin: 0 auto;
        height: 60px;
        line-height: 60px;
      }
    }
    .feature-content {
      width: 1514px;
      margin: 0 auto;
      margin-top: 30px;
      background-color: #fff;
      .feature-content-top {
        height: 80px;
        line-height: 80px;
        padding-top: 30px;
        .feature-content-tip {
          float: left;
          margin-left: 100px;
         
          font-size: 18px;
          color: rgba(0,0,0,0.85);
        }
        .feature-content-tip-value {
          float: left;
          margin-left: 10px;
         
          font-size: 16px;
          color: rgba(0,0,0,0.45);
        }
        .feature-content-radio {
          margin-left: 300px;
        }
        .feature-input {
          width: 346px;
          height: 45px;
          margin-left: 50px;
        }
        .add-feature {
          background-color: #FD4734;
          border-color: #FD4734;
          color: #fff;
          width: 130px;
          height: 45px;
          /*padding: 10px 25px;*/
          margin-left: 50px;
        }
        .import-feature {
          color: #FD4734;
          font-size: 30px;
          margin-left: 30px;
        }
        .import-feature-down {
          font-size: 20px;
          color: #7A7A7A;
          margin-left: 5px;
        }
      }
      .feature-content-collapse {
        margin-top: 50px;
        .custom-collapse-header {
          display: flex;
          width: 100%;
          justify-content: center;
          align-items: center;
          .custom-header-item {
            display: flex;
            flex: 1;
            .custom-header-img {
              width: 62px;
              height: 56px;
              margin-top: 7px;
            }
            .custom-subheader-img {
              width: 26.6px;
              height: 26.6px;
              /*margin-left: 110px;*/
            }
            .center-item-author {
              color: #666;
              margin-left: 10px;
            }
            .center-item-date {
              margin-left: 30px;
              font-size: 14px;
              color: rgba(0,0,0,0.25);
            }
            .custom-header-title {
             
              font-size: 14px;
              color: #333333;
              margin-left: 20px;
              align-items: center;
              line-height: 80px;
              .custom-header--down {
                font-size: 14px;
                margin-left: 30px;
              }
            }
            .header-center-item {
              width: 40%;
             
              font-size: 14px;
              color: rgba(0,0,0,0.45);
            }
            .custom-header-icon {
              font-size: 18px;
              color: #8F8F8F;
            }
            .custom-header-num {
             
              font-size: 14px;
              color: #8C8C8C;
              margin-left: 10px;
            }
          }
          .custom-header-item-right {
            justify-content: flex-end;
            margin-right: 20px;
          }
        }
        .custom-collapse-sub {
          height: 80px;
          /*line-height: 80px;*/
          border-bottom: 1px solid #E9E9E9;
        }
      }
    }

  }
  .feature-modal-body {
    .feature-modal {
      .feature-modal-title {
        height: 68px;
        margin: 20px 0;
      }
      .feature-modal-desc {
        width: 720px;
        height: 279px;
      }
      .feature-modal-btn {
        text-align: center;
        margin-top: 30px;
        button {
          width: 100px;
          height: 37px;
          line-height: 37px;
        }
      }
    }
  }



  /deep/ .ant-breadcrumb {
    height: 60px;
    line-height: 60px;
  }
  /deep/ .ant-radio-group-large .ant-radio-button-wrapper {
    height: 50px;
    padding: 8px 37px;
  }
  /deep/ .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    color: #FD4734;
    border-color: #FD4734;
    box-shadow: -1px 0 0 0 #FD4734;
  }
  /deep/ .ant-collapse {
    width: 1400px;
    margin: 0 auto;
    border: none;
    background-color: #fff;
  }
  /deep/ .ant-collapse>.ant-collapse-item>.ant-collapse-header {
    height: 94px;
  }
  /deep/ .ant-collapse-content>.ant-collapse-content-box {
    background-color: #fafafa;
  }

</style>
